class TextInputLineItemProperties extends HTMLElement {
  inputTextCounter;
  inputTextField;

  constructor() {
    super();
    const inputTextField = this.querySelector("input[type='text']");
    const inputTextArea = this.querySelector("textarea");

    this.inputTextField = inputTextField || inputTextArea;
    this.inputTextCounter = this.querySelector('.character-count .counter');
    this.inputTextField.addEventListener('input', (event) => {
      this.onTextInputChange(event);
      this.triggerValidaion(event);
    });
  }

  connectedCallback() {
    this.inputTextField.disabled = false;
  }

  onTextInputChange(event) {
    this.inputTextCounter.innerHTML = event.target.value.length;
  }

  triggerValidaion(event) {
    document.dispatchEvent(new CustomEvent("input-changed", {
      detail: {
        input: event.target
      }
    }));
  }
}

customElements.define('text-input-lineitem-properties', TextInputLineItemProperties);
